export const environment = {
  production: true,
  environment: 'staging',
  wsBaseUrl: 'https://ws-dev.thesolutionsmovement.org',
  baseUrl: 'https://api-dev.thesolutionsmovement.org',
  apiBaseUrl: 'https://api-dev.thesolutionsmovement.org/api/v5',
  devUrl: 'https://app-dev.thesolutionsmovement.org',
  host: 'thesolutionsmovement.org',
  imageBaseUrl: 'https://d36yzrhbooji3o.cloudfront.net/',
  theme: 'arkius',
  googleAuth: {
    // Public OAuth client IDs for the staging web and native apps.
    webClientId:
      '1062011175001-95sepn03jfda5mkef6aeqqvuu53ur0ip.apps.googleusercontent.com',
    iOSClientId:
      '1062011175001-hf8qcndttm2g3k0i8vtphr15u5lqv8ru.apps.googleusercontent.com',
  },
  appleAuth: {
    iOSClientId: 'com.thesolutionsmovement.app.internal',
    webClientId: 'org.thesolutionsmovement.app.sid',
    redirectUrl: 'https://app-dev.thesolutionsmovement.org/auth/apple/callback',
    androidRedirectUrl:
      'https://api-dev.thesolutionsmovement.org/api/v5/auth/login/social/apple/callback',
  },
  log: (message?: any, ...optionalParams: any[]) => {
    console.log(message, optionalParams);
  },
};
